export default {
  title: "趋势图",
  recent_records: "近期记录",
  preview_report: "预览报告",
  compliant_status_good: "合规状态良好",
  custom_factor_status: "使用自定义因子，合规状态待定",
  tax_amount: "税费金额",
  based_on_eur: "基于 €{amount}",
  total_emission: "总排放量",
  recent_calculation_date: "最近计算日期",
  no_records: "暂无记录",
  calculate_now: "立即计算",
  cbam_news: "CBAM新闻",
  no_news: "暂无新闻",
  usage_stats_and_price: "使用统计与碳价格",
  monthly_calculation_count: "月度计算次数",
  monthly_report_count: "月度报告次数",
  monthly_avg_emission: "月平均排放量",
  today_carbon_price: "今日碳价格",
  current_plan: "当前套餐: {plan}",
  upgrade_now: "立即升级",
  trial_remaining: "剩余 {days} 天，{calculations} 次计算，{reports} 份报告",
  expiry_date: "到期日期: {date}",
  free_plan_desc1: "每月100次计算，每天1份报告",
  free_plan_desc2: "升级以解锁更多功能！",
  trial_expired: "试用期已过期，升级到高级套餐(€99/月)以继续使用",
  config_fetch_failed: "配置获取失败",
};
